var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartyPopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 110,
    viewBox: "0 0 113 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_4901_2862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M72.7972 87.1461L-0.156457 109.808C-3.33251 110.787 -6.29364 107.826 -5.31456 104.65L17.3476 31.6965L72.7972 87.1461Z",
    fill: "#0080E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M75.0413 85.8536C80.3569 80.538 72.041 63.6037 56.4671 48.0298C40.8933 32.456 23.959 24.14 18.6434 29.4556C13.3277 34.7713 21.6437 51.7056 37.2175 67.2794C52.7914 82.8533 69.7257 91.1692 75.0413 85.8536Z",
    fill: "#70C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.337 90.3956L48.2238 94.7896C45.0955 93.6672 42.015 92.3299 38.9822 90.7538C32.3913 87.339 26.0631 82.8734 20.1647 77.4526C19.2095 76.5691 18.1588 75.5661 17.0364 74.4676C14.1469 71.5781 10.8276 67.9006 7.48438 63.5066L10.3739 54.1456C15.6752 62.1216 21.4065 68.0439 25.4183 71.7214C36.6897 82.0615 49.1074 88.3419 62.337 90.3956Z",
    fill: "#70C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.7673 97.7003L27.6392 101.163C21.2632 97.7958 15.1499 93.4257 9.41864 88.1721C8.46343 87.2885 7.41271 86.2856 6.29035 85.1871C4.97694 83.8737 3.56801 82.3931 2.11133 80.7454L4.83366 71.9336C8.46343 76.4231 11.9499 79.9335 14.6723 82.4409C22.2423 89.3661 30.2898 94.4764 38.7673 97.7003Z",
    fill: "#70C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.611 103.983L8.84399 107.015C5.3575 104.627 1.94265 101.905 -1.30505 98.92C-1.85429 98.4185 -2.42741 97.8931 -3.02441 97.2961L-0.421484 88.8903C1.1546 90.538 2.65905 91.9709 3.94857 93.1649C8.65295 97.4872 13.5484 101.093 18.611 103.983Z",
    fill: "#70C0FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.9528 40.9384L33.4902 37.4758C38.9827 31.9834 42.1109 24.9388 42.8035 16.5091C43.3288 10.1092 42.1826 5.26159 42.1587 5.21383L46.9108 4.0437C46.9586 4.25862 48.2481 9.56 47.6989 16.724C46.9586 26.2999 43.2333 34.658 36.9528 40.9384Z",
    fill: "#F74F68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M64.4157 71.8618L60.9531 68.3992C67.7112 61.6412 77.2871 58.2263 88.6302 58.5606C97.0598 58.7994 103.46 60.9964 103.722 61.0919L102.122 65.7008L102.91 63.3844L102.122 65.7008C102.051 65.6769 96.0569 63.6471 88.3436 63.4322C78.3378 63.1695 70.2664 66.0112 64.4157 71.8618Z",
    fill: "#FF9500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M47.5068 35.9929C49.274 33.0556 51.6142 32.2915 53.3097 31.7183C54.7425 31.2407 55.6261 30.9542 56.4619 29.5691C57.2977 28.1841 57.1544 27.2766 56.8917 25.7722C56.5813 24.0051 56.1753 21.5932 57.9424 18.6559C59.7096 15.7187 62.0498 14.9545 63.7453 14.3814C65.1781 13.9038 66.0617 13.6172 66.8975 12.2322C67.7333 10.8471 67.59 9.93968 67.3273 8.43524C67.0169 6.66811 66.6109 4.25622 68.378 1.31897L72.5571 3.82638C71.7213 5.21143 71.8645 6.11887 72.1272 7.62332C72.4377 9.39044 72.8436 11.8023 71.0765 14.7396C69.3094 17.6768 66.9691 18.441 65.2736 19.0141C63.8408 19.4917 62.9573 19.7783 62.1215 21.1633C61.2857 22.5484 61.4289 23.4558 61.6916 24.9603C62.0021 26.7274 62.408 29.1393 60.6409 32.0765C58.8738 35.0138 56.5335 35.778 54.838 36.3511C53.4052 36.8287 52.5217 37.1152 51.6859 38.5003L47.5068 35.9929Z",
    fill: "#FF9500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M67.6624 49.1034L65.2744 44.8528C68.3549 43.1095 70.8385 43.611 72.6534 43.9931C74.2294 44.3035 75.1608 44.4946 76.6891 43.6588C78.1935 42.823 78.5279 41.9155 79.0771 40.3872C79.698 38.644 80.5816 36.2798 83.6621 34.5366C86.7426 32.7933 89.2261 33.2948 91.041 33.653C92.6171 33.9635 93.5484 34.1545 95.0768 33.3187C96.5812 32.4829 96.9155 31.5516 97.4648 30.0471C98.0857 28.3039 98.9692 25.9397 102.05 24.1965L104.438 28.4472C102.933 29.283 102.599 30.2143 102.05 31.7187C101.429 33.462 100.545 35.8261 97.4648 37.5694C94.3843 39.3126 91.9007 38.8111 90.0858 38.4529C88.5097 38.1425 87.5784 37.9514 86.0501 38.7872C84.5456 39.623 84.2113 40.5305 83.6621 42.0588C83.0412 43.8021 82.1576 46.1662 79.0771 47.9094C75.9966 49.6527 73.513 49.1512 71.6982 48.7691C70.1221 48.4348 69.1669 48.2438 67.6624 49.1034Z",
    fill: "#F74F68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M98.635 49.4145C99.9802 49.4145 101.071 48.324 101.071 46.9787C101.071 45.6335 99.9802 44.543 98.635 44.543C97.2898 44.543 96.1992 45.6335 96.1992 46.9787C96.1992 48.324 97.2898 49.4145 98.635 49.4145Z",
    fill: "#FBA2AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M87.7483 77.9254C89.0935 77.9254 90.184 76.8348 90.184 75.4896C90.184 74.1443 89.0935 73.0538 87.7483 73.0538C86.403 73.0538 85.3125 74.1443 85.3125 75.4896C85.3125 76.8348 86.403 77.9254 87.7483 77.9254Z",
    fill: "#FFD294"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M110.218 57.1994C111.563 57.1994 112.654 56.1089 112.654 54.7637C112.654 53.4184 111.563 52.3279 110.218 52.3279C108.873 52.3279 107.782 53.4184 107.782 54.7637C107.782 56.1089 108.873 57.1994 110.218 57.1994Z",
    fill: "#FF61C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M90.3254 23.5032C91.6707 23.5032 92.7612 22.4127 92.7612 21.0674C92.7612 19.7222 91.6707 18.6317 90.3254 18.6317C88.9802 18.6317 87.8896 19.7222 87.8896 21.0674C87.8896 22.4127 88.9802 23.5032 90.3254 23.5032Z",
    fill: "#FBA2AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M54.4074 5.52156C55.7527 5.52156 56.8432 4.43103 56.8432 3.08579C56.8432 1.74056 55.7527 0.650024 54.4074 0.650024C53.0622 0.650024 51.9717 1.74056 51.9717 3.08579C51.9717 4.43103 53.0622 5.52156 54.4074 5.52156Z",
    fill: "#E50089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M71.3401 26.6093C72.6853 26.6093 73.7758 25.5188 73.7758 24.1736C73.7758 22.8283 72.6853 21.7378 71.3401 21.7378C69.9948 21.7378 68.9043 22.8283 68.9043 24.1736C68.9043 25.5188 69.9948 26.6093 71.3401 26.6093Z",
    fill: "#FF9500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M51.9289 56.8395C53.2742 56.8395 54.3647 55.749 54.3647 54.4038C54.3647 53.0585 53.2742 51.968 51.9289 51.968C50.5837 51.968 49.4932 53.0585 49.4932 54.4038C49.4932 55.749 50.5837 56.8395 51.9289 56.8395Z",
    fill: "#F74F68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M27.2805 17.1031C28.6257 17.1031 29.7163 16.0126 29.7163 14.6673C29.7163 13.3221 28.6257 12.2316 27.2805 12.2316C25.9353 12.2316 24.8447 13.3221 24.8447 14.6673C24.8447 16.0126 25.9353 17.1031 27.2805 17.1031Z",
    fill: "#FCC4CD"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4901_2862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.159,
    height: 109.347,
    fill: "white",
    transform: "translate(-5.50684 0.653061)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyPopper);
export default __webpack_public_path__ + "static/media/party-popper.aca9f97a620b9ac9b6b5c7f936dfe1ce.svg";
export { ForwardRef as ReactComponent };